package com.castly.shared.dto

import kotlinx.serialization.Serializable

@Serializable
enum class EpisodeStatusDto {
    DRAFT,
    PUBLISHED,
    ARCHIVED
}

@Serializable
enum class VideoProviderDto {
    TG,
    YOUTUBE,
    OTHER_URL
}

@Serializable
data class EpisodeTranslationData(
    val title: String,
    val description: String? = null,
    val author: String? = null,
    val transcript: String? = null
)

@Serializable
data class EpisodeDto(
    val id: String,
    val podcastId: String,
    val title: String,
    val slug: String,
    val description: String? = null,
    val audioUrl: String? = null,
    val imageUrl: String? = null,
    val originalImageUrl: String? = null,
    val durationSeconds: Int? = null,
    val fileSizeBytes: Long? = null,
    val episodeNumber: Int? = null,
    val seasonNumber: Int? = null,
    val status: EpisodeStatusDto = EpisodeStatusDto.DRAFT,
    val publishedAt: String? = null,
    val createdAt: String,
    val updatedAt: String,
    val translations: Map<String, EpisodeTranslationData> = emptyMap(),
    // Linked episode fields
    val rssGuid: String? = null,
    val isLinked: Boolean = false,
    val originalAudioUrl: String? = null,
    // RSS metadata fields
    val subtitle: String? = null,
    val summary: String? = null,
    // Video fields
    val videoProvider: VideoProviderDto? = null,
    val videoUrl: String? = null,
    val videoId: String? = null,
    // Parent content context (Feature 014 - User Story 7)
    val contentId: String? = null,
    val contentType: String? = null  // "podcast" | "audiobook"
)

@Serializable
data class CreateEpisodeRequest(
    val title: String,
    val description: String? = null,
    val audioUrl: String? = null,
    val imageUrl: String? = null,
    val durationSeconds: Int? = null,
    val fileSizeBytes: Long? = null,
    val episodeNumber: Int? = null,
    val seasonNumber: Int? = null,
    val translations: Map<String, EpisodeTranslationData> = emptyMap(),
    val subtitle: String? = null,
    val summary: String? = null,
    val videoProvider: VideoProviderDto? = null,
    val videoUrl: String? = null,
    val videoId: String? = null
)

@Serializable
data class UpdateEpisodeRequest(
    val title: String? = null,
    val description: String? = null,
    val audioUrl: String? = null,
    val imageUrl: String? = null,
    val durationSeconds: Int? = null,
    val fileSizeBytes: Long? = null,
    val episodeNumber: Int? = null,
    val seasonNumber: Int? = null,
    val status: EpisodeStatusDto? = null,
    val translations: Map<String, EpisodeTranslationData>? = null,
    val subtitle: String? = null,
    val summary: String? = null,
    val videoProvider: VideoProviderDto? = null,
    val videoUrl: String? = null,
    val videoId: String? = null
)

@Serializable
data class EpisodeListResponse(
    val items: List<EpisodeDto>,
    val total: Int,
    val page: Int,
    val pageSize: Int
)

@Serializable
data class StreamingUrlResponse(
    val streamingUrl: String,
    val expiresIn: Long // seconds
)
